module.exports = __webpack_public_path__ + "728b159f1113b94cf3969c77f5c7712f.svg";